<template>
  <div class="antialiased grid grid-cols-12 bg-app-primary-grey--black-squeeze text-black">
    <section class="row-start-1 col-span-full">
      <slot name="skiplinks">
        <MoleculeSkiplink id="#maincontent" :text="$t('skiplinks.maincontent')" />
      </slot>
    </section>

    <header class="row-start-2 col-span-full xl:sticky top-0 z-50">
      <div class="relative">
        <!-- Navigation -->
        <section>
          <!-- Don't move this slot unless you have a very good reason!! -->
          <slot name="backButton" />
          <!-- Don't move this slot unless you have a very good reason!! -->
          <slot name="mobileLyre" />

          <OrganismDesktopMenu />
        </section>

        <!-- Don't move this slot unless you have a very good reason!! -->
        <slot name="notifications" />
      </div>
    </header>

    <OrganismMobileMenu />

    <OrganismPageOverlay />

    <main id="maincontent" class="col-span-full row-start-3">
      <!-- Control panel component to render admin tools when ?cp=true is added in the url -->
      <ClientOnly>
        <OrganismControlPanel />
      </ClientOnly>

      <section class="lg:row-start-5">
        <OrganismModal :name="'favoriteModal'" :visible="overlayIsOpen" background-color="white" @close-modal="favoritesCloseOverlay()">
          <div class="pr-6 sm:pr-10">
            <h3 class="text-base sm:text-lg lg:text-2xl font-semibold leading-snug text-black mb-3 md:mb-5">
              {{ $t('favorites.default.overlay-text') }}
            </h3>
            <MoleculeButton
              :url="tixLoginUrl"
              target="_self"
              :enable-icon-left="false"
              size="large"
              class="group-hover:bg-app-primary-1-red--fire-brick group-focus:bg-app-primary-1-red--fire-brick w-fit z-10"
            >
              {{ $t('favorites.default.overlay-button-text') }}
            </MoleculeButton>
          </div>
        </OrganismModal>
      </section>
      <!-- Rest of the page slot, to be found in a specific template -->
      <slot></slot>
    </main>

    <OrganismFooter class="col-span-full row-start-4" />

    <!-- Always load the TixState component, it is responsible for the customer state -->
    <OrganismTixState />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  page: { type: Object as PropType<Record<string, any>>, required: false, default: () => ({}) },
})

const favoritesStore = useFavoritesStore()
const { tixLoginUrl } = setupTix()

// setupBodyOverflow() // does not work properly!! it also adds the class overflow-hidden on desktop which causes serious UX problems on the agenda when you reset the filters! commented until further notice...
setupGtmPageView(props.page)
setupGtmUserInfo()

const overlayIsOpen = computed(() => favoritesStore.overlayIsOpen)

function favoritesCloseOverlay() {
  favoritesStore.closeOverlay()
}
</script>
